import { useEffect } from "react";

import { useAuthContext } from "shared/utils/hooks/useAuthContext";

import CheckoutOnepageOffers from "@CheckoutOnepageOffers/index";
import { useUserCheckoutAutocompleteInfos } from "@payment/g/[uuid]/hooks/useUserCheckoutAutocompleteInfos/index.";
import CheckoutStepsOffers from "@payment/pages/CheckoutStepsOffers";
import { IInitialData } from "@payment/providers/CheckoutProvider/dtos";
import { useCheckoutContext } from "@payment/providers/CheckoutProvider/useCheckoutContext";
import { captureException, captureMessage } from "@sentry/nextjs";

interface ICheckoutTemplateProps {
  initialData: IInitialData;
  promoterLink: any;
  productData: any;
  clientIp: string;
}

export const CheckoutTemplate = ({
  initialData,
  promoterLink,
  productData,
  clientIp,
}: ICheckoutTemplateProps) => {
  const { updateAddessState, updateCreditCardState, updateUserSettings } =
    useCheckoutContext();
  const { loggedUser } = useAuthContext();
  const { loadUserCheckoutInfos, userCheckoutInfos } =
    useUserCheckoutAutocompleteInfos();

  useEffect(
    function checkoutAutoCompleteInfosInitialRequest() {
      try {
        loadUserCheckoutInfos();
      } catch (error) {
        console.log(
          "Erro (CheckoutTemplate | checkoutAutoCompleteInfosInitialRequest): ",
          error,
        );
        captureException(error);
        captureMessage(
          "Erro (CheckoutTemplate | checkoutAutoCompleteInfosInitialRequest)",
        );
      }
    },
    [loggedUser],
  );

  useEffect(() => {
    updateAddessState(userCheckoutInfos?.addressList);
    updateCreditCardState(userCheckoutInfos?.creditCardList);
    updateUserSettings(userCheckoutInfos?.userSettings);
  }, [userCheckoutInfos]);

  const isCheckoutSteps =
    productData?.offer?.details?.checkout_format === "steps";

  if (isCheckoutSteps)
    return (
      <CheckoutStepsOffers
        offer={productData}
        initialData={initialData}
        promoterLink={promoterLink}
        couponInitialState={null}
        clientIp={clientIp}
      />
    );
  else
    return (
      <CheckoutOnepageOffers
        offer={productData}
        initialData={initialData}
        promoterLink={promoterLink}
        couponInitialState={null}
        clientIp={clientIp}
      />
    );
};
